<bepatient-dynamic-menu-icon [icon]="icon" [color]="iconColor">
</bepatient-dynamic-menu-icon>

<span class="label" #labelRef>
  {{ label }}
</span>

<span
  class="notification"
  [style.display]="notifications ? 'block' : 'none'"
  [style.background]="color"
>
  {{ notifications }}
</span>
